


























import {Vue, Component} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AclMixin } from '@/components/acl/acl-mixin';

import ProfileForm from './forms/profile.vue';
import ReportingForm from './forms/reporting.vue';
import RedirectForm from './forms/redirect.vue';

import api, { GeneralApi } from './api';

@Component({
  components: {
    ProfileForm,
    ReportingForm,
    RedirectForm
  }
})

export default class GeneralSettings extends mixins(AclMixin) {
  api: GeneralApi = api;
}
